import instance from "./base.api";

// Tipos
export interface UserData {
  id: number;
  username: string;
  nombre: string;
  mail: string;
  rol: string;
  porcentaje: number;
  telefono: string | null;
  eliminado: number;
  created?: string;
  modified?: string;
}

export interface CreateUserData {
  username: string;
  password: string;
  nombre: string;
  mail: string;
  rol: string;
  porcentaje: number;
  telefono?: string;
}

export interface UpdateUserData {
  username?: string;
  password?: string;
  nombre?: string;
  mail?: string;
  rol?: string;
  porcentaje?: number;
  telefono?: string;
}

// Obtener todos los usuarios activos
export const getUsers = async (): Promise<UserData[]> => {
  const response = await instance.get<UserData[]>("/users");
  return response.data;
};

// Obtener usuario por ID
export const getUserById = async (id: number): Promise<UserData> => {
  const response = await instance.get<UserData>(`/users/${id}`);
  return response.data;
};

// Crear usuario
export const createUser = async (data: CreateUserData): Promise<UserData> => {
  const response = await instance.post<UserData>("/users", data);
  return response.data;
};

// Actualizar usuario
export const updateUser = async (id: number, data: UpdateUserData): Promise<UserData> => {
  const response = await instance.put<UserData>(`/users/${id}`, data);
  return response.data;
};

// Desactivar usuario (soft delete)
export const deactivateUser = async (id: number): Promise<{ message: string }> => {
  const response = await instance.patch<{ message: string }>(`/users/${id}/deactivate`);
  return response.data;
};

// Activar usuario
export const activateUser = async (id: number): Promise<{ message: string }> => {
  const response = await instance.patch<{ message: string }>(`/users/${id}/activate`);
  return response.data;
};
